<tux-nav
  *ngIf="user"
  [appName]="appName"
  [user]="user"
  [impersonatingUser]="impersonatingUser"
  [navData]="navData"
  [navProfileData]="navProfileData"
  [navPlatformData]="navPlatformData"
  [domain]="domain"
  [homeLink]="homeLink"
></tux-nav>
<main id="mainId" style="overflow-x: hidden">
  <tux-banner-container [globalBanner]="true"></tux-banner-container>
  <ng-content></ng-content>
</main>
